import { PermissionsEnums } from "app/services/api/types/authorisation/enums/PermissionsEnums";
import { usePermissionCheck } from "app/services/permissions/usePermissionCheck";
import { View } from "ui/atoms/view";
import { Button, ButtonIcon, ButtonText } from "ui/gluestack/button";
import { EditIcon } from "ui/gluestack/icon";

interface Props {
  permission?: PermissionsEnums;
  startEdit: () => void;
}
export function EditButton({ permission, startEdit }: Props) {
  const { checkPermission } = usePermissionCheck();

  if (permission && !checkPermission(permission)) return null;
  return (
    <View className="items-end mb-4">
      <Button variant="link" onPress={startEdit} className="px-2 lg:px-0">
        <ButtonText>Edit</ButtonText>

        <ButtonIcon as={EditIcon} />
      </Button>
    </View>
  );
}
